import { render, staticRenderFns } from "./JournalNotes.vue?vue&type=template&id=b8e1961e&"
import script from "./JournalNotes.vue?vue&type=script&lang=js&"
export * from "./JournalNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports